// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__JrCpG","resendInfoText":"OnGoingPaymentBox_resendInfoText__2wi8N"};